var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sponsors.length > 0)?_c('div',{staticClass:"pt-4 pb-3 px-2"},[_c('app-caption',{staticClass:"ml-2 mb-3",attrs:{"path":"premiere-sponsors"}}),_c('sponsor',{attrs:{"comfortable":"","slug":"qomplx"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }